import { Select } from "@themes/pollinator/ui/Select";
import { TimezoneOption } from "@core/features/timezones";

export type Props = {
  options: TimezoneOption[];
  value: string;
  onChange: (val: TimezoneOption | null) => void;
};

export function SchedulingTimezoneSelect({ options, value, onChange }: Props) {
  const onBlur = () => {
    setTimeout(() => {
      // Create a fake nudge that forces layout shift to reset the zoom
      const scrollY = window.scrollY;
      window.scrollTo(0, scrollY + 1);
      window.scrollTo(0, scrollY);
    }, 0);
  };

  return (
    <Select
      name="timezone"
      value={options.find((option) => option.value === value) || null}
      onChange={(val) => onChange(val as TimezoneOption | null)}
      className="w-full"
      options={options}
      onBlur={onBlur}
    />
  );
}

export default SchedulingTimezoneSelect;

